import React from 'react'

// Node Modules
import { useTranslation } from 'react-i18next'

// Components
import { ShowAllIcon, HideAllIcon } from 'components/SASIcon'

// Styles
import styles from './ExpandCollapseAll.module.scss'

interface Props {
  target: string,
  sectionLabel: string,
  content:  React.ReactNode
}

const ExpandCollapseAll = ({ target, sectionLabel, content}:Props) => {

  const { t } = useTranslation()
  const targetElem = document.getElementById(target)
  let collapsibleElems = targetElem ? targetElem.getElementsByClassName('collapsible') : []

  function expandAll() {
    
    for (let i=0; i<collapsibleElems.length; i++) {
      let classes = collapsibleElems[i].className;
      if (classes.indexOf('hidden') > -1) {
       let target = collapsibleElems[i].children[0] as HTMLElement
       target.click()
      }
    }
  }

  function collapseAll() {
    for (let i=0; i<collapsibleElems.length; i++) {
      let classes = collapsibleElems[i].className;
      if (classes.indexOf('hidden') < 0) {
        let target = collapsibleElems[i].children[0] as HTMLElement
        target.click()
      }
    }
  }

  let expandAllBtn = <a role="button" aria-label={t('helpcenter-gui-icu.content.collapse.expand_all_button.aria', {sectionLabel})} href="javascript:void(0)" onClick={expandAll}><ShowAllIcon />{t('helpcenter-gui-icu.content.collapse.expand_all_button.label')}</a>/* eslint-disable-line */
  let collapseAllBtn = <a role="button" aria-label={t('helpcenter-gui-icu.content.collapse.collapse_all_button.aria', {sectionLabel})} href="javascript:void(0)" onClick={collapseAll}><HideAllIcon />{t('helpcenter-gui-icu.content.collapse.collapse_all_button.label')}</a>/* eslint-disable-line */

  return (
    <div className={styles.casTitleOverride}>
      <div className={styles.expandCollapseHeader}>{content}</div>
      <div className={styles.expandCollapseBar}>
        {expandAllBtn}
        {collapseAllBtn}
      </div>
    </div>
  )
}

export default ExpandCollapseAll